/// <amd-module name="Test/TestPlansLibrary/Pivots/TestCasesPivot/Component/TestCasesTableItemProvider" />
import { ITestCaseItem } from "../Redux/TestCasesContracts";
import { ObservableValue, ObservableArray } from "VSS/Core/Observable";
import { IListSelection } from "VSSUI/List";
import { ISelectionRange } from "VSSUI/Utilities/Selection";

export class TestCasesTableItemProvider {
    private _items: ObservableArray<ITestCaseItem | ObservableValue<ITestCaseItem | undefined>>;

    constructor() {
        this._items = new ObservableArray<ITestCaseItem | ObservableValue<ITestCaseItem | undefined>>();
    }

    public getTestCaseItems(testCases: ITestCaseItem[], selection?: IListSelection, addShimmerRow?: boolean): ObservableArray<ITestCaseItem | ObservableValue<ITestCaseItem | undefined>> {
        // Clear the observable array if there are no test cases
        if (!testCases || testCases.length == 0) {
            this._items.removeAll();

            if (addShimmerRow) {
                this._items.push(this._getShimmerRow());
            }

            return this._items;
        }

        // store the indices of the items that the user may have selected in the table (used during paging where we render all items)
        const selectedIndices: number[] = [];
        if (selection && selection.value && selection.value.length > 0) {
            const length: number = selection.value.length;
            for (let i = 0; i < length; i++) {
                const selectionRange: ISelectionRange = selection.value[i];

                if (selectionRange) {
                    for (let j = selectionRange.beginIndex; j <= selectionRange.endIndex; j++) {
                        selectedIndices.push(j);
                    }
                }
            }
        }

        // clear all the items first
        this._items.removeAll();

        // testCases[] contains the stuff we want to render (covers both filtered and non-filtered cases)
        for (let i = 0; i < testCases.length; i++) {
            const item = {
                ...testCases[i],
                ...testCases[i].columnOptionValues
            };
            this._items.push(item);
        }

        // restore the selected indices so we maintain the user selected cases in the new render
        if (selection && selectedIndices && selectedIndices.length > 0) {
            for (const idx of selectedIndices) {
                selection.select(idx, 1, true);
            }
        }

        if (addShimmerRow) {
            this._items.push(this._getShimmerRow());
        }

        return this._items;
    }

    private _getShimmerRow(): ObservableValue<ITestCaseItem | undefined> {
        return new ObservableValue<ITestCaseItem | undefined>(undefined);
    }
}
